export default "__VITE_ASSET__DTMO8yA1__"